/**
 * @module:  OKR 页面汇总
 * @author: Liang Huang 
 * @date: 2020-05-07 14:36:31 
 */

import { lazy } from 'react';
import { retry } from '@src/utils/tool';

// OKR列表
export const OKRList = lazy(() => retry(() => import('@src/pages/OKR/OKRList/index')));
// OKR创建目标
export const OKRCreate = lazy(() => retry(() => import('@src/pages/OKR/OKRCreate/index')));
// OKR详情
export const OKRDetail = lazy(() => retry(() => import('@OKR/OKRDetail/index')));
// OKR设置
export const OKRSetting = lazy(() => retry(() => import('@OKR/OKRSetting/index')));
// KR详情
export const KRDetail = lazy(() => retry(() => import('@OKR/KRDetail/index')));
// KR详情
export const KRCreate = lazy(() => retry(() => import('@OKR/KRCreate/index')));
